import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import loading from './loading.store';

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    loading,
  }
})
